export const HD_LINE_TEXT_REVIEW_PANEL_KEY = 'line-text-review';

/** Filter in het reviewoverzicht: alles, nog te doen, goedgekeurd of herschreven. */
export type HdLineTextReviewFilter = 'all' | 'open' | 'approved' | 'edited';
